module.exports = __webpack_public_path__ + "static/media/icon_account.17df0105.svg";